import api from './api.js'
import {track,newExposureId} from '../analytics.js'
const exposures = new Map()

// Старый журнал сохраняем параллельно с новой собственной аналитикой.
// surface отделяет старые окна от A/B первого пейвола.
export function reportPaywallEvent(surface, event, meta = {}) {
  if(event==='shown') exposures.set(surface,newExposureId())
  const name={shown:'paywall_shown',cta:'paywall_cta',register:'paywall_cta',close:'paywall_closed'}[event]
  if(name)track(name,{surface,exposure_id:exposures.get(surface)})
  void api.post('/paywall/event', { event, meta: { ...meta, surface } }).catch(() => {})
}
